// src/services/customerService.js
import axios from "../api/axiosInstance";

export const getCustomerInfo = () => {
  return axios.get("/Customer/CustomerInfo");
};
